import styled from "styled-components";

export const Header = styled.header`
  height: 5rem;
  padding: 0 1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 2px 0 rgba(3, 3, 3, 0.15);
`;
